/* ==========================================================================
   Colleet — custom.js
   Site-wide custom JavaScript. Loaded with `defer` near end of <body>
   in layout/theme.liquid.
   ========================================================================== */
(function () {
  'use strict';

  /* ------------------------------------------------------------------------
     SECTION 1 — Announcement ticker
     Wrap the announcement-bar blocks in a `.colleet-announce-track` and
     clone the items once so the CSS marquee can loop seamlessly.
     ------------------------------------------------------------------------ */
  function initAnnouncementTicker() {
    // Section is rendered inside the `header-group` section group, so its
    // wrapper id is `shopify-section-sections--HASH__announcement-bar`.
    // This selector also matches the standalone `shopify-section-announcement-bar`.
    var section = document.querySelector('[id^="shopify-section"][id$="announcement-bar"]');
    if (!section) return;

    // Avoid double-init (Shopify section reload, etc.)
    if (section.querySelector('.colleet-announce-track')) return;

    var bars = section.querySelectorAll(':scope > .announcement-bar');
    if (bars.length === 0) return;

    var track = document.createElement('div');
    track.className = 'colleet-announce-track';

    // Move existing bars into the track
    bars.forEach(function (bar) {
      track.appendChild(bar);
    });

    // Clone once for seamless looping (animation translates by -50%)
    var originals = Array.prototype.slice.call(track.children);
    originals.forEach(function (item) {
      var clone = item.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      track.appendChild(clone);
    });

    section.appendChild(track);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAnnouncementTicker);
  } else {
    initAnnouncementTicker();
  }

  // Re-init when Shopify theme editor reloads the section.
  // sectionId may be the bare key ("announcement-bar") or the group-prefixed
  // form ("sections--HASH__announcement-bar") — match either.
  document.addEventListener('shopify:section:load', function (e) {
    var id = e.detail && e.detail.sectionId;
    if (id && /(^|__)announcement-bar$/.test(id)) {
      initAnnouncementTicker();
    }
  });

  /* ------------------------------------------------------------------------
     SECTION 2A — Cart label
     Stockholm already provides visible labels for Search and Account via
     `.header__icon-name`; our CSS unhides them. We only need to render a
     dynamic "Cart (N)" label and keep it in sync with cart updates.
     ------------------------------------------------------------------------ */
  function readCartCount() {
    var bubble = document.querySelector('#cart-icon-bubble .cart-count-bubble [aria-hidden="true"]');
    if (bubble) {
      var n = parseInt(bubble.textContent.trim(), 10);
      if (!isNaN(n)) return n;
    }
    return 0;
  }

  function updateCartLabel() {
    var cart = document.getElementById('cart-icon-bubble');
    if (!cart) return;
    var count = readCartCount();
    var label = cart.querySelector('.colleet-nav-label');
    if (!label) {
      label = document.createElement('span');
      label.className = 'colleet-nav-label';
      cart.appendChild(label);
    }
    label.textContent = 'Cart (' + count + ')';
  }

  function initNavTextLabels() {
    updateCartLabel();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initNavTextLabels);
  } else {
    initNavTextLabels();
  }

  // Stockholm broadcasts cart updates via the global PUB_SUB_EVENTS bus
  // (see assets/pubsub.js / cart.js). Listen for cartUpdate events so the
  // label stays in sync after add/remove without a page reload.
  document.addEventListener('cart:update', updateCartLabel);
  if (window.subscribe && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
    window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, updateCartLabel);
  }

  // Theme editor: re-init when the header section is reloaded
  document.addEventListener('shopify:section:load', function (e) {
    var id = e.detail && e.detail.sectionId;
    if (id && /(^|__)header$/.test(id)) {
      initNavTextLabels();
    }
  });
})();
